export type RuntimeRequestConfig = {
	href: string;
	method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
};

export type RuntimeOauth2Config = {
	client_id?: string;
	token_url?: string;
};

export type RuntimeConfig = {
	api_url?: string;
	data_href?: RuntimeRequestConfig;
	end_href?: RuntimeRequestConfig;
	exit_url?: string;
	oauth2?: RuntimeOauth2Config;
	container_id?: string;
	mount_id?: string;
};

const runtimeConfig: RuntimeConfig = typeof window !== 'undefined' ? window.config || {} : {};

const config = {
	api_url: runtimeConfig.api_url || '',
	squla_api_url: import.meta.env.VITE_SQULA_API_URL || '',
	speak_api_url: import.meta.env.VITE_SPEAK_API_URL || '',
	enable_speak_audio: import.meta.env.VITE_ENABLE_SPEAK_AUDIO !== 'false',
	use_dummy_game_data: import.meta.env.VITE_USE_DUMMY_GAME_DATA === 'true',
	resources_url: import.meta.env.VITE_RESOURCES_URL || '',
	frontend_url: import.meta.env.VITE_FRONTEND_URL || '',
	data_href: runtimeConfig.data_href,
	end_href: runtimeConfig.end_href,
	exit_url: runtimeConfig.exit_url || '',
	oauth_client_id: runtimeConfig.oauth2?.client_id || import.meta.env.VITE_OAUTH_CLIENT_ID || 'learning_path@squla',
	oauth_token_url: runtimeConfig.oauth2?.token_url || '',
	oauth_client_secret: import.meta.env.VITE_OAUTH_CLIENT_SECRET || '',
	oauth_username: import.meta.env.VITE_OAUTH_USERNAME || '',
	oauth_password: import.meta.env.VITE_OAUTH_PASSWORD || '',
	container_id: runtimeConfig.container_id || '',
	mount_id: runtimeConfig.mount_id || '',
	authentication_cookies_domain: import.meta.env.VITE_AUTHENTICATION_COOKIES_DOMAIN || '',
	authentication_cookies_suffix: import.meta.env.VITE_AUTHENTICATION_COOKIES_SUFFIX || '',
	environment: import.meta.env.VITE_ENVIRONMENT || '',
	brand_name: import.meta.env.VITE_BRAND_NAME || '',
	bugsnag_api_key: import.meta.env.VITE_BUGSNAG_API_KEY || '',
	react_app_build_number: import.meta.env.VITE_BUILD_NUMBER || '',
	build_url: import.meta.env.VITE_BUILD_URL || '.',
};

export default config;
